package com.vizio.redwolf.utils

import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.headers

data class AppConfig(val appVersion: String)

fun HttpRequestBuilder.applyAppConfig(appConfig: AppConfig) {
    val appVersion = appConfig.appVersion
    if (appVersion.isNotEmpty()) {
        headers {
            append(HEADER_APP_VERSION, appVersion)
        }
    }
}